import { Controller } from '@hotwired/stimulus'
import { showToast } from '../lib/toast'
import { Howl } from 'howler'

const checkSound = new Howl({
  src: ['/checkmark.wav'],
})

const handleCheckAnimationEnd = event => {
  const element = event.currentTarget

  element.classList.remove('animate__animated', 'animate__bounceIn', '')
  element.removeEventListener('animationend', handleCheckAnimationEnd)
}

/*
 * This controller is responsible for submitting reading entries via XHR and
 * re-rendering the reading entry form state to reflect the submission.
 */
export default class extends Controller {
  static targets = ['check']

  update(e) {
    e.preventDefault()

    const scrollY = window.scrollY
    const url = this.element.action
    const data = new URLSearchParams(new FormData(this.element))

    const checkEl = this.checkTarget
    checkEl.classList.add('animate__animated')
    checkEl.addEventListener('animationend', handleCheckAnimationEnd)

    checkSound.play()

    fetch(`${url}?${data}`, {
      method: 'POST',
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.body)
        }

        return response
      })
      .then(response => response.text())
      .then(html => {
        // Updates form with the new check state
        this.element.innerHTML = html
        window.scrollTo(0, scrollY)
      })
      .then(() => {
        // Dispatch update-badges event so badges controller can update itself
        const event = new CustomEvent('update-badges')
        window.dispatchEvent(event)
      })
      .catch(() => {
        showToast('There was an error saving this reading entry', 'error')
      })
  }
}
